import { IDataProviderFilter, IFilter } from 'core-components/types'

export const isIDataProviderFilter = (
  value: IDataProviderFilter | IFilter
): value is IDataProviderFilter => {
  return (value as IDataProviderFilter).logic !== undefined
}
